// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".FreeformQuestion-cls1___4ca2e1675dfcb20b831{/*!*/}.FreeformQuestion-cls2__bed30beaeb87e03b3323{margin-bottom:16px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "FreeformQuestion-cls1___4ca2e1675dfcb20b831",
	"cls2": "FreeformQuestion-cls2__bed30beaeb87e03b3323 FreeformQuestion-cls1___4ca2e1675dfcb20b831"
};
export default ___CSS_LOADER_EXPORT___;
